import { indicateWheatType } from '@/modules/common/helpers/wheat-type.helper';
import { DiContainer } from '@/modules/di/di-container';
import { OfferDetails } from '@/modules/mixing/ts/buyers-prices.types';
import { IInitialFormState } from '@/modules/seller-account/hooks/use-add-offer.hook';
import { Modal, notification } from 'antd';
import { unix } from 'dayjs';
import md5 from 'md5';
import { BuyerAccountOffersService } from '../services/buyer-account-offers.service';
import { createBuyerOfferFx, fetchBuyerOffersFx } from '../store/offers.store';

const buyerOfferService = DiContainer.get(BuyerAccountOffersService);

export const createBuyerOffer = async ({
  formState,
  date,
  buyerInfo,
  closeFn,
}: ICreateBuyerOfferArgs) => {
  try {

    Modal.confirm({
      title: 'Подтвердите действие',
      content: `создать предложение с указанной датой истечения ${formState.expiryDate}?`,
      centered: true,
      okText: 'да',
      okButtonProps: { style: { backgroundColor: '#66B28A' } },
      cancelText: 'назад',
      onOk: async () => {
        const unixTimestamp =
          new Date(
            date.year,
            date.month - 1,
            date.day,
            date.hours,
            date.minutes,
          ).getTime() / 1000;
        const res: any = await createBuyerOfferFx({
          year: formState.year,
          gluten: formState.gluten,
          idk: formState.idk,
          clop: formState.clop,
          protein: formState.protein,
          cp: formState.cp,
          nature: formState.nature,
          humidity: formState.humidity,
          weed: formState.weed,
          admixture_other_cereals: formState.admixtureOtherCereals,
          wheat_different_type: formState.wheatDifferentType,
          price: String(formState.buyingPrice),
          other: null,
          fusarium: null,
          sunflower_seeds: null,
          grain_admixture: null,
          expiration_offer: String(unixTimestamp),
          //buyer_id: String(buyerInfo?.id),
          pickup: formState.pickup,
          wheat_class: String(formState.wheatClass),
          wheat_type: String(
            indicateWheatType(String(formState.sort), String(formState.type)),
          ),
          class: `${String(formState.wheatClass)}-й класс`,
          type: String(
            indicateWheatType(String(formState.sort), String(formState.type)),
          ),
        });
        if ('error' in res) {
          try {
            const errorRes = res as any;
            const errorArray = Object.keys(errorRes?.error?.errors).reduce(
              (result, key) => {
                return result.concat(errorRes.error.errors[key]);
              },
              [],
            );
            if (errorArray && errorArray.length > 0) {
              errorArray.map((item) => notification.error({ message: item }));
              return;
            }
          } catch (err) {
            return notification.error({
              message: 'Непредвиденная ошибка. Попробуйте позже.',
            });
          }
        }
        notification.success({ message: 'Предложение успешно добавлено в систему!' });
        await fetchBuyerOffersFx();
        closeFn();
      },
      onCancel: () => {
        return;
      },
    });
  } catch (err) {
    notification.warning({
      message: 'Ошибка при создании предложения. Попробуйте, пожалуйста, позже',
    });
  }
};

export interface ICreateBuyerOfferArgs {
  date: {
    year: number;
    month: number;
    day: number;
    hours: number;
    minutes: number;
  };
  closeFn: () => void;
  formState: IInitialFormState;
  buyerInfo: any;
}
